import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import SimpleDDL from "../../../modules/SimpleDDL";
import IndentUnitBelumProses from "./indentUnitBelumProses/indentUnitBelumProsesTable";
import IndentUnitSudahProses from "./indentUnitSudahProses/indentUnitSudahProsesTable";
import Api from "../../../Services/Api";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import dayjs from "dayjs";
import {getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../common/mapper";
import {fetchDataAsync, getUserAccess} from "../../../Services/Utils";

class IndentUnit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userAccess: null,
            tabIndex: 0,
            loading: false,
            submittedFilterData: {},
            kodeCabang: null,
            cabangOptions: [],
            filterData: {},
            searchData: {},
            pagination: {
                totalData: 1,
                page: 1,
                limit: 5,
            },
            dataTable: [],
            skipNextPaginationFetch: false
        };
    }

    componentDidMount() {
        this.fetchDataCabang()
    }

    fetchDataCabang = async () => {
      const { menuAccess, setError } = this.props;
      this.setState((prevValue) => ({ ...prevValue, loading: true }));
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
        setError: setError,
        menuName: "PO UNit",
        args: null,
      });
    
      if (res.ok) {
        const filteredData = res.data.data.filter((item) =>
          menuAccess.map((data) => data.idRefObj).includes(item.kodeCabang),
        );
    
        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            cabangOptions: filteredData.map((item) => ({
              ...item,
              label: item.namaDealer,
              value: item.kodeCabang,
            })),
            kodeCabang: {
              label: filteredData[0].namaDealer,
              value: filteredData[0].kodeCabang,
            },
            userAccess: getUserAccess(menuAccess, filteredData[0].kodeCabang),
          }));
        }
        await this.fetchData({kodeCabang: filteredData[0].kodeCabang})
      }
      this.setState((prevValue) => ({ ...prevValue, loading: false }));
    };

    async componentDidUpdate(_, prevState) {
        if (prevState.tabIndex !== this.state.tabIndex) {
            this.fetchData();
        }

        if (
          (prevState.pagination.page !== this.state.pagination.page ||
            prevState.pagination.limit !== this.state.pagination.limit) &&
          !this.state.skipNextPaginationFetch
        ) {
          this.fetchData(
            this.state.submittedFilterData,
            this.state.pagination.page,
            this.state.pagination.limit
          );
        }
        if (this.state.skipNextPaginationFetch) {
          this.setState({ skipNextPaginationFetch: false });
        }
    }

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            submittedFilterData: {...filter},
        }));
        const response = await Api.create("NAGAMAS_TRANSACTION").getAllIndentUnit({
            paramFilters: {
                kodeCabang: this.state.kodeCabang?.value || "",
                listIndentStatus: this.state.tabIndex === 0 ? ["DRAFT"] : ["CANCELLED", "DEAL"],
                ...filter,
            },
            page,
            limit,
        });
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: response.data?.data || [],
                pagination: {
                    ...prevValue.pagination,
                    totalData: response.data.totalData,
                },
                userAccess: getUserAccess(this.props.menuAccess, this.state.kodeCabang.value)
            }));
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleSubmitFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {},
            skipNextPaginationFetch: true
        }));
        const request = removeNullFields({
            ...this.state.filterData,
            namaVariant: getValueFromDDL(this.state.filterData, "namaVariant"),
            namaWarna: getValueFromDDL(this.state.filterData, "namaWarna"),
            paymentPlan: getValueFromDDL(this.state.filterData, "paymentPlan"),
            startIndentDate: this.formatDate(this.state.filterData?.startIndentDate || null),
            endIndentDate: this.formatDate(this.state.filterData?.endIndentDate || null),
            indentDeposit: getValueFromDDL(this.state.filterData, "indentDeposit"),
            ageIndentUnit: this.state.filterData?.ageIndentUnit
                ? parseInt(this.state.filterData.ageIndentUnit)
                : "",
        });

        this.handleResetPagination()
        this.fetchData(request, 1, this.state.pagination.limit);
    };

    handleResetPagination = () => {
      this.setState((prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }));
    };

    handleSearch = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
        let fieldName = "kodeVariant";
        if (this.state.searchData?.key?.value === "Nama Varian") {
            fieldName = "namaVariant";
        }
        this.handleResetPagination()

        this.fetchData({
            [fieldName]: this.state.searchData?.value || "",
        }, 1, this.state.pagination.limit);
    };

    handleCabangChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
            searchData: {},
            filterData: {},
            submittedFilterData: {},
            loading: true,
        }));
        this.handleResetPagination()
        await this.fetchData({
            kodeCabang: value.value,
        }, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
        }));
    };

    formatDate = (value) => {
        return value ? dayjs(value).format("DD-MM-YYYY") : "";
    };

    refetch = () => {
        this.setState(
          (prev) => ({
            skipNextPaginationFetch: true,
          }),
          () => {
            this.fetchData(
              this.state.submittedFilterData,
              this.state.pagination.page,
              this.state.pagination.limit
            );
          }
        );
    };

    render() {
        return (
            <>
                <Container>
                    <SimpleDDL
                        id="select_options_nama_cabang"
                        box="search"
                        name="kodeCabang"
                        containerclassname="width width-250px"
                        placeholder="Nama cabang hak akses"
                        options={this.state.cabangOptions}
                        value={this.state.kodeCabang}
                        onChange={(value, {name}) => this.handleCabangChange(name, value)}
                    />
                    <Tabs
                        selectedIndex={this.state.tabIndex}
                        onSelect={(index) =>
                            this.setState((prevValue) => ({
                                ...prevValue,
                                tabIndex: index,
                                filterData: {},
                                searchData: {},
                                submittedFilterData: {},
                                pagination: {
                                    totalData: 1,
                                    page: 1,
                                    limit: 5,
                                },
                            }))
                        }
                    >
                        <TabList>
                            <Tab>Belum Proses</Tab>
                            <Tab>Sudah Proses</Tab>
                        </TabList>
                        <TabPanel>
                            <IndentUnitBelumProses
                                state={this.state}
                                refetch={this.refetch}
                                onSetState={this.handleStateChange}
                                onSubmitFilter={this.handleSubmitFilter}
                                onSearch={this.handleSearch}
                                userAccess={this.state.userAccess}
                            />
                        </TabPanel>
                        <TabPanel>
                            <IndentUnitSudahProses
                                state={this.state}
                                onSetState={this.handleStateChange}
                                onSubmitFilter={this.handleSubmitFilter}
                                onSearch={this.handleSearch}
                                userAccess={this.state.userAccess}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

export default IndentUnit;
